import {
  OTPClubRegistrationRequest,
  OTPRegistrationResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../../axios';

const registerOtvcUser = async (requestBody: OTPClubRegistrationRequest) => {
  const { data } = await axios.post<OTPRegistrationResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/club/otp/registration`,
    requestBody
  );

  return data;
};

export const useRegisterClubOtvcUserMutation = () =>
  useMutation({
    mutationFn: (requestBody: OTPClubRegistrationRequest) =>
      registerOtvcUser(requestBody),
  });
